export type ChangeTradingViewChartSymbolAction = {
    type: 'changeTradingViewChartSymbol';
    tabId: string;
    symbol: string;
};
export const changeTradingViewChartSymbol = (tabId: string, symbol: string): ChangeTradingViewChartSymbolAction => ({
    tabId,
    symbol,
    type: 'changeTradingViewChartSymbol',
});

export type UpdateTradingViewChartSymbolAction = {
    type: 'updateTradingViewChartSymbol';
    tabId: string;
    symbol: string;
};
export const updateTradingViewChartSymbol = (tabId: string, symbol: string): UpdateTradingViewChartSymbolAction => ({
    tabId,
    symbol,
    type: 'updateTradingViewChartSymbol',
});

export type UpdateTradingViewChartStateAction = {
    type: 'updateTradingViewChartState';
    tabId: string;
    chartState: object;
    interval: string;
    timezone: string;
};
export const updateTradingViewChartState = (
    tabId: string,
    chartState: object,
    interval: string,
    timezone: string,
): UpdateTradingViewChartStateAction => ({
    tabId,
    chartState,
    interval,
    timezone,
    type: 'updateTradingViewChartState',
});

export type TradingViewChartActions =
    | UpdateTradingViewChartSymbolAction
    | ChangeTradingViewChartSymbolAction
    | UpdateTradingViewChartStateAction;
